import modalLoaderFactory from './factory'
import registerStore from './registerStore'
import ModalLoader from './components/modal-loader'

const install = (Vue, store) => {
  Vue.component('ModalLoader', ModalLoader)

  registerStore(store)

  Object.defineProperty(Vue.prototype, '$modalLoader', {
    get () {
      return modalLoaderFactory(this)
    }
  })
}

export default { install }



// WEBPACK FOOTER //
// ./src/plugins/modal-loader/index.js